import { Component, OnInit } from '@angular/core';
import { Slide } from 'src/app/models/slide';
import { SlidesService } from 'src/app/services/slides.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-slides',
  templateUrl: './slides.component.html',
  styleUrls: ['./slides.component.scss']
})
export class SlidesComponent implements OnInit {
  public newSlide: Slide=new Slide({});
  public slides:Slide[];
  public imagePathBase:string='';

  constructor(
    private _slides:SlidesService
  )
  {
    this.imagePathBase=environment.apiEndpoint;
  }

  ngOnInit() {
    this.getSlides();
  }

  public getSlides()
  {
    this._slides.getSlides().subscribe(data=>{
      this.slides=data;
    });
  }

  public saveNewSlide()
  {
    if(!this.newSlide.title) return alert('Slide title cannot be null');
    if(!this.newSlide.slide) return alert('Slide must have an image');
    this._slides.createSlide(this.newSlide).subscribe(data=>{
      this.resetSlide();
      this.getSlides();
    });
  }

  public resetSlide()
  {
    this.newSlide=new Slide({});
  }

  public setSlideStatus(event:any, id:number)
  {
    this._slides.setSlideStatus(event.target.checked, id).subscribe(data=>{
      console.log(data);
    });
  }

  public moveUp(id:number)
  {
    this._slides.moveUp(id).subscribe(data=>{
      this.getSlides();
    });
  }

  public moveDown(id:number)
  {
    this._slides.moveDown(id).subscribe(data=>{
      this.getSlides();
    });
  }

  public deleteSlide(id:number)
  {
    if(!confirm('Delete this slide?')) return false;
    this._slides.deleteSlide(id).subscribe(data=>{
      this.getSlides();
    });
  }

  public getImageData(imageData:any){
    this.newSlide.slide=imageData[1];
    this.newSlide.filetype=imageData[0];
  }

}
